import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "redux/store";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Routes and pages
import routes from "./routes";
import ProtectedRoutes from "./protectedRoutes";
import Dashboard from "./pages/Dashboard";
import Subscription from "./pages/subscription/Subscription";
import Wallet from "./pages/Wallet";
import ActivityLog from "./pages/ActivityLog";
import UserManagement from "./pages/user-management/UserManagement";
import Request from "./pages/request/Request";
import Settings from "./pages/Settings";
import AdminLogin from "./pages/auth/AdminLogin";
import AdminForgotPassword from "pages/auth/AdminForgotPassword";
import AdminResetPassword from "pages/auth/AdminResetPassword";
import EnterprisePlan from "pages/enterprise-plan/Enterprise";
import CompanyDetails from "pages/enterprise-plan/CompanyDetails";
import PaymentTokenConfirmation from "pages/auth/PaymentTokenConfirmation";

const App = () => {
  return (
    <Provider store={store}>
        <Router>
          <ToastContainer /> {/* Toast notification container */}
          <Routes>
            <Route element={<ProtectedRoutes />}>
              <Route path={routes.Dashboard} element={<Dashboard />} />
              <Route path={routes.Subscription} element={<Subscription />} />
              <Route path={routes.Wallet} element={<Wallet />} />
              <Route path={routes.ActivityLog} element={<ActivityLog />} />
              <Route path={routes.UserManagement} element={<UserManagement />} />
              <Route path={routes.Request} element={<Request />} />
              <Route path={routes.Settings} element={<Settings />} />
              <Route path={routes.EnterprisePlan} element={<EnterprisePlan />} />
              <Route path={routes.CompanyDetails} element={<CompanyDetails />} />
            </Route>
            <Route path={routes.PaymentTokenConfirmation} element={<PaymentTokenConfirmation />} />
            <Route path={routes.AdminLogin} element={<AdminLogin />} />
            <Route path={routes.AdminForgotPassword} element={<AdminForgotPassword />} />
            <Route path={routes.AdminResetPassword} element={<AdminResetPassword />} />
            <Route path="*" element={<div className="text-center p-5"><h1>Page Not Found</h1></div>} />
          </Routes>
        </Router>
    </Provider>
  );
};

export default App;
